import useTiclickTableConfig from '@shared/hooks/use-ticlick-table-config';
import { TABLES_KEYS } from '@shared/constants/tables-keys';

import reminderLogsApi from '@src/features/reminders/services/reminder-logs-api';

import { automatedRemindersColumns } from './automated-reminders-columns';
import { AutomatedReminderLogViewButton } from './automated-log-view-button';
import { ReminderLogResendButton } from './reminder-log-resend-button';
import { AUTOMATED_REMINDER_LOG_TYPES } from '../reminder-type-filters';
import { ActionItemProps } from '@src/design-system/molecules/ticlick-table/ticlick-table-table-actions';
import { TReminderLog } from '@src/shared/types/reminder';
// import ExportEntity from '@src/shared/components/export-entity';
import { useHasPermission } from '@shared/hooks/use-has-permission';
import { entities } from '@src/shared/constants/entities';
import { CreateReminderTriggerButton } from '../../create-reminder';
import { Button } from '@src/design-system/button';
import { RefreshLeftSquare } from 'iconsax-react';

export function useAutomatedRemindersTable() {
  const hasPermission = useHasPermission();

  const actionsTable: ActionItemProps<TReminderLog>[] = [
    // {
    //   key: 'export',
    //   render: (table) => {
    //     const viewId = table.getState().globalFilter?.view as
    //       | string
    //       | undefined;

    //     return (
    //       <ExportEntity
    //         entity='REMINDER_LOGS'
    //         view={viewId ? Number(viewId) : undefined}
    //       />
    //     );
    //   },
    //   minWidth: 100,
    //   visibility: 'none-selection',
    // },
    {
      key: 'resend',
      visibility: 'selection',
      render: (table) => (
        <ReminderLogResendButton
          ids={table.getSelectedRowModel().rows.map((row) => row.original.id)}
          trigger={
            <Button
              type='button'
              variant='ghost'
              className='text-[#211835] border border-[#DBD3F0] h-[44px]'
            >
              <RefreshLeftSquare className='size-4 text-secondary-1000' />
              Resend
            </Button>
          }
        />
      ),
    },
    {
      key: 'add',
      visibility: 'none-selection',
      minWidth: 77,
      render: () => <CreateReminderTriggerButton />,
      isDisplay: hasPermission(entities.reminderLog, 'add'),
    },
    // {
    //   key: 'custom-fields',
    //   visibility: 'none-selection',
    //   minWidth: 77,
    //   render: () => <CustomFieldListDialogTrigger />,
    // },
  ];

  const table = useTiclickTableConfig({
    fetchingData: {
      fetchFn: reminderLogsApi.useFetch,
      query: { reminder_type: AUTOMATED_REMINDER_LOG_TYPES },
    },
    options: {
      columns: automatedRemindersColumns,
    },
    identifyingData: { tableKey: TABLES_KEYS.automatedReminderLogsTable },
    rowActions: [
      {
        key: 'resend',
        render: (row) => <ReminderLogResendButton ids={[row.original.id]} />,
        minWidth: 36,
      },
      {
        key: 'view',
        render: (row) => <AutomatedReminderLogViewButton row={row} />,
        minWidth: 36,
      },
    ],
  });

  return { table, actionsTable };
}
